function mapMaintenanceAssetRows(rows) {
    return (Array.isArray(rows) ? rows : [])
        .map((each) => each?.assets)
        .filter(Boolean);
}

/** 상세 DTO에서 자산 목록 추출 */
export function getMaintenanceAssetsFromDetail(detail) {
    return mapMaintenanceAssetRows(detail?.maintenanceAssets);
}

/** 상세 DTO에서 담당자 목록 추출 */
export function getMaintenanceHandlersFromDetail(detail) {
    return Array.isArray(detail?.handlers) ? detail.handlers : [];
}
